<template>
<el-dialog :visible="!!detail" title="查看详情" width="1000px" @close="closeDialog">
   <el-form :model="info" ref="form" :rules="rules" label-width="150px">
     <el-form-item label="期数:" prop="period">
        <el-input-number v-model="info.period" :controls="false" :min="0" :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item label="币种:" prop="coinType">
        <el-select v-model="info.coinType" placeholder="请选择币种">
          <el-option label="所有币种" value=""></el-option>
          <el-option v-for="coin in coinTypes" :label="coin" :value="coin" :key="coin"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="起止时间：" required>
        <el-col :span="7">
          <el-form-item prop="startTime" >
            <el-date-picker v-model="info.startTime" value-format="timestamp" type="datetime" placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="endTime">
            <el-date-picker v-model="info.endTime" value-format="timestamp" type="datetime" placeholder="选择截止时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="天数:" prop="day">
        <el-input-number v-model="info.day" :controls="false" :min="0" :precision="0"></el-input-number>
      </el-form-item>
       <el-form-item label="最小存币数量:" prop="minAmount">
        <el-input-number v-model="info.minAmount" :controls="false" :min="0"></el-input-number>
      </el-form-item>
       <el-form-item label="最大小数位:" prop="scale">
        <el-input-number v-model="info.scale" :controls="false" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="总量:" prop="totalAmount">
        <el-input-number v-model="info.totalAmount" :controls="false" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="年利率:" prop="annualrate">
        <el-input-number @keyup.native="getPercent" v-model="info.annualrate" :controls="false"  :min="0">
        </el-input-number>
        <span class="sub-text" v-if="percent">
           {{percent }}%
        </span>
      </el-form-item>
      <el-form-item label="锁仓币种:" prop="lockCoin">
        <el-select v-model="info.lockCoin" placeholder="请选择币种">
          <el-option label="所有币种" value=""></el-option>
          <el-option v-for="coin in coinTypes" :label="coin" :value="coin" :key="coin"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="锁仓数量:" prop="lockAmount">
        <el-input-number v-model="info.lockAmount" :controls="false" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="锁仓加成:" prop="lockAddition">
        <el-input-number v-model="info.lockAddition" :controls="false" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="邀请奖励:" prop="inviteAward">
        <el-input-number v-model="info.inviteAward" :controls="false" :min="0"></el-input-number>
      </el-form-item>


    </el-form>
  <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
</el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import math from 'common/math';

export default {
  name: 'PledgeInterestDetail',
  data() {
    const validateStartTime = (rule, value, callback) => {
      if (!this.detail.startTime) {
        callback(new Error('请填写'));
      }
      if (this.detail.startTime < new Date())
        callback(new Error('开始时间不得早于当前时间'));
      callback();
    };
    const validateEndTime = (rule, value, callback) => {
      if (!this.detail.endTime) {
        callback(new Error('请填写'));
      }
      if (
        this.detail.startTime &&
        this.detail.endTime &&
        value < this.detail.startTime
      )
        callback(new Error('截止时间不得早于开始时间'));
      callback();
    };
    const notZero = (rule, value, callback) => {
      if (value === 0) callback(new Error('不得为0'));
      if (!value) {
        callback(new Error('请填写'));
      }
      callback();
    };
    return {
      info: {},
      percent: undefined,
      rules: {
        day: {
          validator: notZero,
          trigger: 'blur'
        },
        coinType: {
          required: true,
          message: '请填写'
        },
        totalAmount: {
          validator: notZero,
          trigger: 'blur'
        },
        annualrate: {
          validator: notZero,
          trigger: 'blur'
        },
        minAmount: {
          validator: notZero,
          trigger: 'blur'
        },
        scale: {
          required: true,
          message: '请填写',
          trigger: 'blur'
        },
        startTime: [
          {
            validator: validateStartTime,
            trigger: 'change'
          }
        ],
        endTime: [
          {
            validator: validateEndTime,
            trigger: 'change'
          }
        ]
      }
    };
  },
  computed: {
    ...mapState('pledgeInterest', ['detail', 'coinTypes'])
  },
  watch: {
    detail(val) {
      if (val) {
        this.info = (val && Object.assign({}, val)) || {};
        if (!isNaN(Number(val.annualrate))) {
          this.percent = math.multiply(val.annualrate, 100);
        }
      } else {
        this.info = {};
        this.percent = undefined;
      }
    }
  },
  methods: {
    ...mapMutations('pledgeInterest', ['setDetail']),
    ...mapActions('pledgeInterest', ['update']),
    closeDialog() {
      this.setDetail(null);
      this.percent = undefined;
      this.$refs['form'].resetFields();
    },
    getPercent(e) {
      const value = e.target.value;
      if (!isNaN(Number(value))) {
        this.percent = math.multiply(value, 100);
      }
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.update(this.info).then(() => {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.closeDialog();
            this.$emit('refresh', {
              page: 1
            });
          });
        }
      });
    }
  }
};
</script>
<style>
.sub-text {
  color: #999;
}
</style>
